import { useQuery } from '@tanstack/react-query'
import { useFormContext } from 'react-hook-form'

import { useApi } from '@fortem-monorepo/react-spa'
import { FormError } from '@fortem-monorepo/react-ui'
import { MultiSelectCreate } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface TagsFormFieldProps {}

export const TagsFormField: React.FC<TagsFormFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<{ tags: string[] }>()

  const api = useApi()

  const tags = useQuery({
    queryKey: ['static', 'trade-tags'],
    queryFn: () => api.misc.getTradeTags(),
  })

  return (
    <FormField
      control={control}
      name="tags"
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Tags</FormLabel>
              <FormError />
            </div>
            <MultiSelectCreate
              items={tags.data}
              value={value}
              onValueChange={(val) => setValue('tags', val, { shouldValidate: true })}
            />
          </FormItem>
        )
      }}
    />
  )
}
